<template>
  <transition name="fade">
    <div class="c-overlay" :style="{ zIndex: overlay.zIndex }" @click.stop="handleClick"></div>
  </transition>
</template>

<script>
  export default {
    name: 'Overlay',
    
    props: {
      overlay: {
        type: Object,
        required: true
      }
    },

    methods: {
      handleClick () {
        return (typeof this.overlay.onClose === 'function') ? this.overlay.onClose() : null;
      }
    }
  };
</script>


// WEBPACK FOOTER //
// ../../../../resources/assets/js/app/plugins/overlay/Overlay.vue